import axios from "axios";
import { store } from "../store";

const api = axios.create({
  baseURL: process.env.VUE_APP_IDENTITY_API,
});

/*
api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
api.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
*/

// api.defaults.headers.common["X-CSRF"] = "1";

api.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      console.log("401");
      localStorage.clear();
      sessionStorage.clear();
      const logoutUrl = `/bff/logout?sid=${(store.getters.loggedInUser ? store.getters.loggedInUser.sid : '')}`
      window.location.href = logoutUrl;
      return response;
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.data) {
      // add your code
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

export default {
  errorHandler(error: Array<any>) {
    console.log(error);
  },
  get(url: string, params: any) {
    return api.get(url, params);
  },
  post(url: string, data: any) {
    return api.post(url, data);
  },
  put(url: string, data: Array<any>) {
    return api.put(url, data);
  },
  delete(url: string) {
    return api.delete(url);
  },
};
